export default function siteTitleFactory($rootScope, houseService) {
    var factory = this;

    factory.setForSearch = function (houses) {
        var searchFilter = houseService.searchFilter;

        // console.log(houses.ViewType);
        // console.log(searchFilter.houseCategory);
        // console.log(searchFilter.houseType);

        var pageTitle;

        if (houses.ViewType == 1) {
            if (searchFilter.houseType && searchFilter.houseType.ID != -1) {
                pageTitle = searchFilter.houseType.Name;
            }

            if (
                searchFilter.houseType &&
                searchFilter.houseType.ID == -1 &&
                searchFilter.houseCategory &&
                searchFilter.houseCategory.CategoryID == 0
            ) {
                pageTitle = searchFilter.houseCategory.Name; // alle should be aktiviteter
            }
        }

        if (houses.ViewType == 2) {
            if (
                searchFilter.houseCategory &&
                searchFilter.houseCategory.CategoryID != 0
            ) {
                pageTitle = searchFilter.houseCategory.Name;
            } else {
                pageTitle = searchFilter.houseType.Name;
            }
        }

        if (houses.ViewType == 3 && houses.ParentLanes.length > 0) {
            // console.log(searchFilter.houseCategory);
            // console.log(searchFilter.houseType);

            if (
                searchFilter.houseType.ID != -1 &&
                searchFilter.houseCategory.CategoryID != 0
            ) {
                pageTitle =
                    searchFilter.houseCategory.Name +
                    " - " +
                    searchFilter.houseType.Name;
            } else {
                pageTitle = houses.ParentLanes[0].HallName;
            }
        }

        if (pageTitle) {
            $rootScope.$broadcast("set-page-title-root", {
                title: pageTitle,
            });
            //$scope.$broadcast('set-page-title', { title: title });
        }
    };

    return factory;
}
